import { render, staticRenderFns } from "./CriarAnotacaoModal.vue?vue&type=template&id=73c2342d&scoped=true"
import script from "./CriarAnotacaoModal.vue?vue&type=script&lang=js"
export * from "./CriarAnotacaoModal.vue?vue&type=script&lang=js"
import style0 from "./CriarAnotacaoModal.vue?vue&type=style&index=0&id=73c2342d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c2342d",
  null
  
)

export default component.exports